/**
 * Copyright (c) 2025 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : InfoBadge.jsx
 * description   : {{insert here}}
 * creation date : 21/04/2025
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    Flex,
    Text,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function InfoBadge({ title, BadgeImage, imageToTheRight = false, children, ...rest }) {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <Flex
                direction={
                    ctx.api.utils.adaptiveOption(
                        imageToTheRight ? 'row-reverse' : 'row',
                        imageToTheRight ? 'row-reverse' : 'row',
                        'column'
                    )
                }
                gap={ctx.theme.tokens.space.zero}
                className='info-badge'
                {...rest}
            >
                <Flex
                    width={
                        ctx.api.utils.adaptiveOption(
                            '50%',
                            '50%',
                            ctx.theme.tokens.space.relative.full
                        )
                    }
                    aspectRatio={1}
                    gap={ctx.theme.tokens.space.zero}
                >
                    <img
                        src={BadgeImage}
                        alt=''
                        className='info-badge-image'
                    />
                </Flex>

                <Flex
                    direction='column'
                    justifyContent='center'
                    width={
                        ctx.api.utils.adaptiveOption(
                            '50%',
                            '50%',
                            ctx.theme.tokens.space.relative.full
                        )
                    }
                    aspectRatio={1}
                    padding={
                        ctx.api.utils.adaptiveOption(
                            ctx.theme.tokens.space.xxl,
                            ctx.theme.tokens.space.xl,
                            ctx.theme.tokens.space.large
                        )
                    }
                    gap={ctx.theme.tokens.space.large}
                    className='info-badge-text-parent'
                >
                    <Text
                        fontSize={
                            ctx.api.utils.adaptiveOption(
                                '4rem',
                                '3rem',
                                '2.5rem'
                            )
                        }
                        className='info-badge-title'
                    >
                        {title}
                    </Text>

                    <Text
                        className='info-badge-text'
                    >
                        {children}
                    </Text>
                </Flex>
            </Flex>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default InfoBadge;



// End of file
